import React from "react";

interface TabBtnProps {
  text: string;
  active?: boolean;
  onClick?: () => void;
}

const TabBtn: React.FC<TabBtnProps> = ({ text, onClick, active }) => {
  return (
    <button
      className={`rounded-[3.125rem] px-4 py-2 text-sm font-semibold sm:px-6 sm:py-4 sm:text-base sm:leading-[1.25rem] ${active ? "bg-black text-white" : "border border-[#EAEEF3] bg-white text-[#232323]"} `}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default TabBtn;
